exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handover-form-dialog{min-width:850px}", ""]);

// exports
